import { render, staticRenderFns } from "./ApiKeyAccessRestrictions.vue?vue&type=template&id=c8bd4da4&scoped=true&"
import script from "./ApiKeyAccessRestrictions.vue?vue&type=script&lang=js&"
export * from "./ApiKeyAccessRestrictions.vue?vue&type=script&lang=js&"
import style0 from "./ApiKeyAccessRestrictions.vue?vue&type=style&index=0&id=c8bd4da4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8bd4da4",
  null
  
)

export default component.exports